module.exports = __webpack_public_path__ + "img/37104-038.0a7d9825.jpg";